if (!customElements.get('rr-gallery-lightbox')) {
  customElements.define(
    'rr-gallery-lightbox',
    class RrGalleryLightbox extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('.rr-lightbox');
        this.stage = this.querySelector('[data-rr-lightbox-stage]');
        this.count = this.querySelector('[data-rr-lightbox-count]');

        this.onClick = this.onClick.bind(this);
        this.onKey = this.onKey.bind(this);
        this.onClose = () => this.stage.replaceChildren();
        this.onTouchStart = (event) => (this.touchX = event.touches[0].clientX);
        this.onTouchEnd = (event) => {
          const delta = event.changedTouches[0].clientX - this.touchX;
          if (Math.abs(delta) > 50) this.step(delta < 0 ? 1 : -1);
        };

        this.addEventListener('click', this.onClick);
        this.dialog.addEventListener('keydown', this.onKey);
        this.dialog.addEventListener('close', this.onClose);
        this.dialog.addEventListener('touchstart', this.onTouchStart, { passive: true });
        this.dialog.addEventListener('touchend', this.onTouchEnd);
      }

      // Theme editor re-renders the section on change (shopify:section:load), which disconnects this element.
      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        if (this.dialog.open) this.dialog.close();
      }

      get items() {
        return [...this.querySelectorAll('[data-rr-lightbox-open]')];
      }

      onClick(event) {
        const item = event.target.closest('[data-rr-lightbox-open]');
        if (item) return this.open(this.items.indexOf(item));
        if (event.target.closest('[data-rr-lightbox-prev]')) return this.step(-1);
        if (event.target.closest('[data-rr-lightbox-next]')) return this.step(1);
        // Close button, or a click on the empty area around the media.
        if (
          event.target.closest('[data-rr-lightbox-close]') ||
          event.target === this.dialog ||
          event.target === this.stage ||
          event.target.classList.contains('rr-lightbox__media')
        ) {
          this.dialog.close();
        }
      }

      onKey(event) {
        if (event.key === 'ArrowLeft') this.step(-1);
        if (event.key === 'ArrowRight') this.step(1);
      }

      open(index) {
        this.index = index;
        this.render();
        if (!this.dialog.open) this.dialog.showModal();
      }

      step(direction) {
        const total = this.items.length;
        this.open((this.index + direction + total) % total);
      }

      // Clones the item's media; images switch to full-width sizes so the browser loads a large source.
      render() {
        const clone = this.items[this.index].querySelector('.rr-gallery__media').cloneNode(true);
        clone.className = 'rr-lightbox__media';
        clone.querySelectorAll('img').forEach((img) => {
          img.sizes = '100vw';
          img.loading = 'eager';
        });
        this.stage.replaceChildren(clone);
        clone.querySelectorAll('video').forEach((video) => video.play().catch(() => {}));
        const pad = (n) => String(n).padStart(2, '0');
        this.count.textContent = `${pad(this.index + 1)} / ${pad(this.items.length)}`;
      }
    }
  );
}
